import { NjRouteProperties } from "./NjRouteProperties";

export class NjRoute {
  component: string;
  path: string;
  title?: string;
  params?: any;
  getParameter?:any;

  public constructor(routeProperties:NjRouteProperties){
    this.component = routeProperties.component
    this.path = routeProperties.path
    this.title = routeProperties.title
    this.params = routeProperties.params

    this.getParameter = function(name:string, defaultValue: any):any {
    if (this.params) {
      return this.params[name + ""] ? this.params[name + ""] : defaultValue

    }
    return defaultValue
  }
}
}